export type HeightTypes = typeof heights;

export const heights = {
	header: '7.8rem',
	headerHover: '38rem',
	headerMobile: '6.4rem',
	/** 주요 CTA·폼 제출 */
	buttonMd: '4.4rem',
	/** 보조 버튼 */
	buttonSm: '3.6rem',
	/** MY 등 캡슐 버튼 높이 */
	pill: '2.8rem',
};
